// extracted by mini-css-extract-plugin
export default {"taskList":"List_taskList__DkFHt"};